import axios from "axios";
import { routes } from "constants/routes";

let signOutFunc = null;
let history = null;
let removeUserFunc = null;
export const setupApiInterceptorConfig = (
  signOutFuncRef,
  historyRef,
  removeUserFuncRef = null
) => {
  signOutFunc = signOutFuncRef;
  history = historyRef;
  removeUserFunc = removeUserFuncRef;
};

export class Api {
  constructor(endpoint = "", redirectOnUnauthorized = true) {
    this.endpoint = endpoint ? `/${endpoint}` : "";
    this.axios = axios.create({
      baseURL: `${process.env.REACT_APP_AUTHORITY}${this.endpoint}`,
      withCredentials: true,
    });

    this.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // check if the response is 401 Unauthorized
        if (error?.response?.status === 401 && signOutFunc) {
          if (signOutFunc && redirectOnUnauthorized) {
            // Signout the user out and redirect to login
            signOutFunc();
          } else if (removeUserFunc && !redirectOnUnauthorized) {
            // Just remove the stored user
            removeUserFunc();
          }
        }

        // check if the response is 403 Forbidden
        if (error?.response?.status === 403 && history) {
          // Redirect to access denied page
          history.replace(routes.accessDenied);
        }
        return Promise.reject(error);
      }
    );
  }

  method(method = "get", subroute = "", config, payload) {
    let url = subroute;

    if (typeof subroute !== "string") {
      if (typeof subroute !== "number") {
        // eslint-disable-next-line no-console
        console.warn(
          new Error(`WARNING: unknown type of subroute: ${subroute}`)
        );
      }

      url = `${subroute}`;
    }

    return method === "get" || method === "delete"
      ? this.axios[method](url, config)
      : this.axios[method](url, payload, config);
  }

  get(subroute = "", params = undefined, config = {}) {
    return this.method("get", subroute, { params, ...config });
  }

  getFile(subroute, params = undefined, config = {}) {
    return this.get(subroute, params, { responseType: "blob", ...config });
  }

  post(subroute = "", payload = undefined, config = {}) {
    return this.method("post", subroute, config, payload);
  }

  postWithBlobResponse(subroute = "", payload = undefined, config = {}) {
    return this.post(subroute, payload, { responseType: "blob", ...config });
  }

  put(subroute = "", payload = undefined, config = {}) {
    return this.method("put", subroute, config, payload);
  }

  putId(id, payload = {}, config = {}) {
    if (!("id" in payload)) {
      return this.put(id, { id, ...payload }, config);
    }
    return this.put(id, payload, config);
  }

  del(subroute = "", config = {}) {
    return this.method("delete", subroute, config);
  }
}
